import * as d3 from 'd3';
import {applyImageRegular, paintOuterFrame} from './drawelements';
import {paintSill} from './drawelements';
import { drawFrame } from './drawelements';
import { drawRect } from './drawelements';
import { drawGrills } from './drawelements';
import { applyImage } from './drawelements';
import { drawRect1 } from './drawelements';
import { toDecimal } from './controls/conversions';
import './entrydoor.css';






// Function to check if an image exists
function checkImageExists(url) {
  return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true); // Resolves true if the image loads successfully
      img.onerror = () => resolve(false); // Resolves false if the image fails to load
      img.src = url;
      img.crossOrigin = "Anonymous"; // Handle CORS issues
  });
}

// Function to dynamically create a black-and-white image
export function convertToBW(url) {
  return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      img.src = url;
      img.crossOrigin = "Anonymous"; // Handle CORS issues for remote images

      img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          for (let i = 0; i < data.length; i += 4) {
              const red = data[i];
              const green = data[i + 1];
              const blue = data[i + 2];
              const gray = 0.2989 * red + 0.5870 * green + 0.1140 * blue;

              data[i] = gray;
              data[i + 1] = gray;
              data[i + 2] = gray;
          }

          ctx.putImageData(imageData, 0, 0);

          const bwUrl = canvas.toDataURL("image/jpeg"); // Create Base64 string
          resolve(bwUrl);
      };

      img.onerror = (err) => {
          reject(err);
      };
  });
}

// Function to save the image to the server
export async function saveImageToServer(base64Image, filename) {
  try {
      const response = await fetch("http://your-server-url.com/save-image", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              base64Image,
              filename,
          }),
      });

      if (!response.ok) {
        alert("Failed to save the image on the server.")
          throw new Error("Failed to save the image on the server.");
      }
      
      const result = await response.json();
      return result; // Server's response (e.g., URL of the saved image)
  } catch (err) {
      //console.error("Error saving the image:", err);
  }
}

//-----------
export function applySideLiteImages(svg, sizes, imgLink = "https://cdn.indikor.com/bdb4fc59-8372-4282-9e32-485b838a60ff" )
{
  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  
  const Options = {DIRECT : 2, SUBFRAME : 1, BOTTOM_KICK : 3, TOP_BOTTOM_KICK : 4};
  //alert(JSON.stringify(sizes, null, 2));
  let doorType = 1;
  if (sizes && sizes.innerRect2) { doorType = 2; }

  if (1) {
    if (sizes && sizes.r1) {
      applyImage(svg, sizes.r1.x + offsetX + 8 , 
        sizes.r1.y + 6 + sizes.overallHeight , 
        sizes.r1.width , 
        sizes.r1.height , 
        imgLink,
        "stretch", // Explicit fitMode for clarity
        "clip-rect-1s" // Unique clipId
      );
    }
    if (sizes && sizes.r4) {
      applyImage(svg, sizes.r4.x + offsetX + 8, 
        sizes.r4.y + 6  + sizes.overallHeight, 
        sizes.r4.width , 
        sizes.r4.height, 
        imgLink,
        "stretch", // Explicit fitMode for clarity
        "clip-rect-4s" // Unique clipId
      );
    }
    else{
      if ((doorType == 1) && (sizes && sizes.r3)) {
        applyImage(svg, sizes.r3.x + offsetX + 8, 
          sizes.r3.y + 6 + sizes.overallHeight, 
          sizes.r3.width , 
          sizes.r3.height, 
          imgLink,
          "stretch", // Explicit fitMode for clarity
          "clip-rect-4s" // Unique clipId
          );         
      }
    }
  }else {
    if (sizes && sizes.r1) {
      applyImageRegular(svg, sizes.r1.x + offsetX + 8, 
        sizes.r1.y + 6 + sizes.overallHeight, 
        sizes.r1.width , 
        sizes.r1.height, 
        imgLink,
        "clip-rect-1p"
      );
    }
    if (sizes && sizes.r4) {
      applyImageRegular(svg, sizes.r4.x + offsetX + 8, 
      sizes.r4.y + 6 + sizes.overallHeight, 
      sizes.r4.width , 
      sizes.r4.height, 
      imgLink,
      "clip-rect-4p"
      );    
    }
    else{
      if ((doorType == 1) && (sizes && sizes.r3)) {
        applyImageRegular(svg, sizes.r3.x + offsetX + 8, 
          sizes.r3.y + 6 + sizes.overallHeight, 
          sizes.r3.width , 
          sizes.r3.height, 
          imgLink,
          "clip-rect-4p"
          );         
      }
    }
}
}
//---------start---
export function applyDoorLiteImages(svg, sizes, selectedDoorLite, frameData, 
  lites = 1, layout = 'vertical', doorLiteWidth = 100, doorLiteHeight = 332) {
  //lites = 7, layout = 'horizontal', doorLiteWidth = 40, doorLiteHeight = 40) {
    if (frameData.doorLiteData.doorLiteSize === undefined){return;}
    lites = parseInt(frameData.doorLiteData.doorLiteLites);
    if (lites === undefined) lites = 1;
    layout = frameData.doorLiteData.doorLiteSize.layout;
    doorLiteWidth  = 5*frameData.doorLiteData.doorLiteSize.w;//frameData.doorSize;
    doorLiteHeight = 5.5*frameData.doorLiteData.doorLiteSize.h;//frameData.doorHeight;

    if ((!selectedDoorLite) || (!frameData)) { return; }

    frameData.doorHeight = 79; //// Always hardcoded!
    //if (frameData.doorSize > 36) frameData.doorSize = frameData.doorSize - 8;
    //if (frameData.doorSize > 40) frameData.doorSize = frameData.doorSize - 4;
    let imgLink = "/images/" + selectedDoorLite.image;

    const offsetX = -1 * sizes.r1.x;
    const offsetY = sizes.r1.y;

    if (layout === 'vertical' && sizes && sizes.innerRect1) {
      const availableWidth = sizes.r2.width;
      const totalBarWidth = doorLiteWidth * lites;
      const spacing = (availableWidth - totalBarWidth) / (lites + 1); // Equal margins on both sides

      for (let i = 0; i < lites; i++) {
        const initX = sizes.r2.x + offsetX + 8;
        //const finalX = initX + (sizes.r2.width - w) / 2;
        const finalX = sizes.r2.x + offsetX + 8 + spacing + (i * (doorLiteWidth + spacing));
        const finalY = sizes.r2.y + 27.1875; // Hardcoded vertical alignment

        applyImage(svg, finalX, finalY, doorLiteWidth, doorLiteHeight, imgLink, "stretch", `clip-rect-1-${i}`);
      }
    }

    if (layout === 'horizontal' && sizes && sizes.innerRect1) {
      //const availableHeight = sizes.r2.y + 6 + sizes.overallHeight; //sizes.r2.height;
      const availableHeight = sizes.r2.height;

      const totalBarHeight = doorLiteHeight * lites;
      const spacing = (availableHeight - totalBarHeight) / (lites + 1); // Equal margins on both sides
      //sizes.r2.y + 6 + sizes.overallHeight;

      for (let i = 0; i < lites; i++) {
        let finalX = 8 + sizes.r2.x + offsetX + (sizes.r2.width - doorLiteWidth) / 2; // Center horizontally
        //const finalY = 27.1875   + 10 + (i * (40 + 45));
        const finalY = sizes.r3.y + offsetY + spacing + (i * (doorLiteHeight + spacing));

        //const finalY = sizes.r2.y + offsetY + spacing + (i * (doorLiteHeight + spacing));
        //alert(JSON.stringify(sizes, null, 2));
        applyImage(svg, finalX, finalY, doorLiteWidth, doorLiteHeight, imgLink, "stretch", `clip-rect-101-${i}`);
        }
      }

    if (layout === 'vertical' && sizes && sizes.innerRect2) {
      const availableWidth = sizes.r3.width;
      const totalBarWidth = doorLiteWidth * lites;
      const spacing = (availableWidth - totalBarWidth) / (lites + 1); // Equal margins on both sides

      for (let i = 0; i < lites; i++) {
        const finalX = sizes.r3.x + offsetX + 8 + spacing + (i * (doorLiteWidth + spacing));
        const finalY = sizes.r3.y + 27.1875; // Hardcoded vertical alignment

        applyImage(svg, finalX, finalY, doorLiteWidth, doorLiteHeight, imgLink, "stretch", `clip-rect-2-${i}`);
      }
    }

    if (layout === 'horizontal' && sizes && sizes.innerRect2) {
      const availableHeight = sizes.r3.height;
      const totalBarHeight = doorLiteHeight * lites;
      const spacing = (availableHeight - totalBarHeight) / (lites + 1); // Equal margins on both sides

      for (let i = 0; i < lites; i++) {
        const finalX = sizes.r3.x + offsetX + (sizes.r3.width - doorLiteWidth) / 2; // Center horizontally
        const finalY = sizes.r3.y + offsetY + spacing + (i * (doorLiteHeight + spacing));

        applyImage(svg, finalX, finalY, doorLiteWidth, doorLiteHeight, imgLink, "stretch", `clip-rect-2-${i}`);
      }
    }
}

//---------end---
export function applyDoorLiteImages_Works(svg, sizes,selectedDoorLite, frameData, 
                                    lites = 1, layout = 'vertical', doorLiteWidth = 22, doorLiteHeight = 64)
{
  if ((!selectedDoorLite) || (!frameData)) { return;}

  frameData.doorHeight = 79; ////Always hardcoded!
  if (frameData.doorSize > 36) frameData.doorSize = frameData.doorSize - 8;
  if (frameData.doorSize > 40) frameData.doorSize = frameData.doorSize - 4;
  let imgLink = "/images/subimages/" + selectedDoorLite.image;

  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.y;
  if (sizes && sizes.innerRect1) { 
    const w = sizes.r2.width * doorLiteWidth / frameData.doorSize;
    const h = sizes.r2.height * (doorLiteHeight) / frameData.doorHeight;
    const initX = sizes.r2.x + offsetX + 8;
    const initY = sizes.r2.y + 6 + sizes.overallHeight;
    const finalX = initX + (sizes.r2.width - w) / 2;
    //const finalY = initY  + (sizes.r2.height - h) / 2 - 20; - do not remove this line even commented!
    const finalY = 27.1875; //Always hardcoded!
    applyImage(svg, finalX, finalY, w, h, imgLink, "stretch", "clip-rect-1");
  }
  if (sizes && sizes.innerRect2) {
    const w = sizes.r3.width * doorLiteWidth / frameData.doorSize;
    const h = sizes.r3.height * doorLiteHeight / frameData.doorHeight;
    const initX = sizes.r3.x + offsetX + 8;
    const initY = sizes.r3.y + 6 + sizes.overallHeight;
    const finalX = initX + (sizes.r3.width - w) / 2;
    //const finalY = initY  + (sizes.r3.height - h) / 2 - 20; - do not remove this line even commented!
    const finalY = 27.1875; ////Always hardcoded!
    applyImage(svg, finalX, finalY, w, h, imgLink, "stretch", "clip-rect-2");
  }
}
/*
  let color;
  if (doorData?.finish?.exteriorDoor) {
    if (doorData.finish.exteriorDoor === 'White') {
      color = 'White';
    }else{
      if (doorData.finish.exteriorDoor === 'Gentek') {
        if (doorData.finish.gentekColor){
          color = doorData.finish.gentekColor;
        }
      }
    }
  }
  else{color = '#F5F5F5';} //default frame color
  //alert(doorData.doorLite.optionsS)

  let borderColor = doorData.doorLite.optionsS;//'rgb(151, 151, 151)'; //'lightgrey';
  if (!doorData?.doorLite?.optionsS){
      borderColor = 'white';      
  }
      doorData.sideLite.sideLiteOptionsS;
*/
export function paintDoorLite(svg, sizes,doorData = null)
{
  //alert(doorData.sideLite.sideLiteOptionsS)
  let color;
  if (!doorData?.sideLite?.sideLiteOptionsS) {color = 'white';}

/*  if (doorData.finish.exteriorDoor === 'White') {
    color = 'White';
  }else{
    if (doorData.finish.exteriorDoor === 'Gentek') {
      if (doorData.finish.gentekColor){
        color = doorData.finish.gentekColor;
      }
    }
  }*/

  
  let borderColor = doorData.sideLite.sideLiteOptionsS;
  if (!doorData?.sideLite?.sideLiteOptionsS){
    borderColor = 'white';      
  }
  borderColor = 'lightgrey';
  if (doorData?.sideLite?.sideLiteOptionsS){
    color = doorData.sideLite.sideLiteOptionsS;
  }
  color = doorData.sideLite.sideLiteOptionsS;

  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.y;
  if (sizes && sizes.r1) { 
      const w = sizes.r1.width;
      const h = sizes.r1.height;
      const initX = sizes.r1.x + offsetX + 8;
      const initY = sizes.r1.y + 6 + sizes.overallHeight;
      drawTransomRectangle(svg, initX, initY, w, h, color);
  }
  if (sizes && sizes.r4) {
      const w = sizes.r4.width;
      const h = sizes.r4.height;
      const initX = sizes.r4.x + offsetX + 8;
      const initY = sizes.r4.y + 6 + sizes.overallHeight;
      drawTransomRectangle(svg, initX, initY, w, h, color);  
  }
  else{
    if (sizes && sizes.r3) {
        const w = sizes.r3.width;
        const h = sizes.r3.height;
        const initX = sizes.r3.x + offsetX + 8;
        const initY = sizes.r3.y + 6 + sizes.overallHeight;
        drawTransomRectangle(svg, initX, initY, w, h, color);  
    }
  }
  //lines...
  if (sizes && sizes.r1) { 
      const w = sizes.r1.width;
      const h = sizes.r1.height;
      const initX = sizes.r1.x + offsetX + 8;
      const initY = sizes.r1.y + 6 + sizes.overallHeight;
      drawRectOutline(svg, initX, initY, w, h, borderColor, 4);
  } 
  if (sizes && sizes.r4) {
      const w = sizes.r4.width;
      const h = sizes.r4.height;
      const initX = sizes.r4.x + offsetX + 8;
      const initY = sizes.r4.y + 6 + sizes.overallHeight;
      drawRectOutline(svg, initX, initY, w, h, borderColor, 4);  
  }
  else{
    if (sizes && sizes.r3) {
        const w = sizes.r3.width;
        const h = sizes.r3.height;
        const initX = sizes.r3.x + offsetX + 8;
        const initY = sizes.r3.y + 6 + sizes.overallHeight;
        drawRectOutline(svg, initX, initY, w, h, borderColor, 4);  
    }
  }
}

export function paintDoorLite_Old(svg, sizes,doorData = null)
{
  if (!doorData?.finish?.exteriorDoor) return;

  let color;
  if (doorData.finish.exteriorDoor === 'White') {
    color = 'White';
  }else{
    if (doorData.finish.exteriorDoor === 'Gentek') {
      if (doorData.finish.gentekColor){
        color = doorData.finish.gentekColor;
      }
    }
  }

  
  const borderColor = 'rgb(151, 151, 151)'; //'lightgrey';

  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.y;
  if (sizes && sizes.r1) { 
      const w = sizes.r1.width;
      const h = sizes.r1.height;
      const initX = sizes.r1.x + offsetX + 8;
      const initY = sizes.r1.y + 6 + sizes.overallHeight;
      drawTransomRectangle(svg, initX, initY, w, h, color);
  }
  if (sizes && sizes.r4) {
      const w = sizes.r4.width;
      const h = sizes.r4.height;
      const initX = sizes.r4.x + offsetX + 8;
      const initY = sizes.r4.y + 6 + sizes.overallHeight;
      drawTransomRectangle(svg, initX, initY, w, h, color);  
  }
  else{
    if (sizes && sizes.r3) {
        const w = sizes.r3.width;
        const h = sizes.r3.height;
        const initX = sizes.r3.x + offsetX + 8;
        const initY = sizes.r3.y + 6 + sizes.overallHeight;
        drawTransomRectangle(svg, initX, initY, w, h, color);  
    }
  }
  //lines...
  if (sizes && sizes.r1) { 
      const w = sizes.r1.width;
      const h = sizes.r1.height;
      const initX = sizes.r1.x + offsetX + 8;
      const initY = sizes.r1.y + 6 + sizes.overallHeight;
      drawRectOutline(svg, initX, initY, w, h, borderColor, 4);
  } 
  if (sizes && sizes.r4) {
      const w = sizes.r4.width;
      const h = sizes.r4.height;
      const initX = sizes.r4.x + offsetX + 8;
      const initY = sizes.r4.y + 6 + sizes.overallHeight;
      drawRectOutline(svg, initX, initY, w, h, borderColor, 4);  
  }
  else{
    if (sizes && sizes.r3) {
        const w = sizes.r3.width;
        const h = sizes.r3.height;
        const initX = sizes.r3.x + offsetX + 8;
        const initY = sizes.r3.y + 6 + sizes.overallHeight;
        drawRectOutline(svg, initX, initY, w, h, borderColor, 4);  
    }
  }
}

export function getExteriorDoorcolor(doorData = null)
{
  const doorDataCopy = {...doorData};
  let color;
  if (doorDataCopy?.finish?.exteriorDoor) {
    if (doorDataCopy.finish.exteriorDoor === 'White') {
      color = 'White';
    }else{
      if (doorDataCopy.finish.exteriorDoor === 'Gentek') {
        if (doorDataCopy.finish.gentekColor){
          color = doorDataCopy.finish.gentekColor;
        }
      }
    }
  }
  else{color = '#F5F5F5';} //default frame color
  return color;
}

export function paintDoor(svg, sizes,doorData = null)
{
  const doorDataCopy = {...doorData};
  let color;
  if (doorDataCopy?.finish?.exteriorDoor) {
    if (doorDataCopy.finish.exteriorDoor === 'White') {
      color = 'White';
    }else{
      if (doorDataCopy.finish.exteriorDoor === 'Gentek') {
        if (doorDataCopy.finish.gentekColor){
          color = doorDataCopy.finish.gentekColor;
        }
      }
    }
  }
  else{color = '#F5F5F5';} //default frame color
  //alert(doorDataCopy.doorLite.optionsS)

  let borderColor = doorDataCopy.doorLite.optionsS;//'rgb(151, 151, 151)'; //'lightgrey';
  if (!doorDataCopy?.doorLite?.optionsS){
      borderColor = 'white';      
  }
  //borderColor = 'lightgrey';

  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  if (sizes && sizes.innerRect1) {
    drawTransomRectangle(svg, sizes.r2.x + offsetX + 8, 
                      sizes.r2.y + 6 + sizes.overallHeight, 
                      sizes.r2.width - 1, 
                      sizes.r2.height, 
                      color );
    drawTransomRectangle(svg, sizes.r2.x + offsetX + 8 + 8 + 2, 
                      sizes.r2.y + 6 + sizes.overallHeight + 12, 
                      sizes.r2.width -16 - 7, 
                      sizes.innerRect1.height, borderColor);
                    }
  if (sizes && sizes.innerRect2) {
    drawTransomRectangle(svg, sizes.r3.x + offsetX + 8 , 
                    sizes.r3.y + 6  + sizes.overallHeight, 
                    sizes.r3.width - 1, 
                    sizes.r3.height, 
                    color /*'brown'*/);
    drawTransomRectangle(svg, sizes.r3.x + offsetX + 8 + 8 + 2, 
                    sizes.r3.y + 6  + sizes.overallHeight + 12, 
                    sizes.r3.width -16 - 7, 
                    sizes.innerRect1.height, 
                    borderColor);
  }

  if (sizes && sizes.innerRect1) { //draw rectangle only
    drawRectOutline(svg, sizes.r2.x + offsetX + 8, 
                      sizes.r2.y + 6 + sizes.overallHeight, 
                      sizes.r2.width , 
                      sizes.r2.height, 'lightgrey', 3)    
                    }
  if (sizes && sizes.innerRect2) { //draw rectangle only
    drawRectOutline(svg, sizes.r3.x + offsetX + 8 , 
                    sizes.r3.y + 6  + sizes.overallHeight, 
                    sizes.r3.width , 
                    sizes.r3.height, 
                    'lightgrey', 3);
  }
}

export function applyDoorImages(svg, sizes, imgLink = "/images/Artsy_bw.jpeg") //"https://cdn.indikor.com/44fe92a4-5217-4844-8f67-404f093f4dde")
{
  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  if (sizes && sizes.innerRect1) {
      applyImage(svg, sizes.r2.x + offsetX + 8, 
                      sizes.r2.y + 6 + sizes.overallHeight, 
                      sizes.r2.width, 
                      sizes.r2.height, 
                      imgLink,
                      "stretch", // Explicit fitMode for clarity
                      "clip-rect-1" // Unique clipId
                );
  }
  if (sizes && sizes.innerRect2) {
    applyImage(svg, sizes.r3.x + offsetX + 8, 
                    sizes.r3.y + 6  + sizes.overallHeight, 
                    sizes.r3.width , 
                    sizes.r3.height, 
                    imgLink,
                    "stretch", // Explicit fitMode for clarity
                    "clip-rect-2" // Unique clipId
              );
  }
}
export function applyDoorImagesOLD(svg, sizes, imgLink = "/images/Artsy_bw.jpeg") //"https://cdn.indikor.com/44fe92a4-5217-4844-8f67-404f093f4dde")
{
  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  if (sizes && sizes.innerRect1) {
      applyImage(svg, sizes.innerRect1.x + offsetX + 8, 
                      sizes.innerRect1.y + 6 + sizes.overallHeight, 
                      sizes.innerRect1.width , 
                      sizes.innerRect1.height, 
                      imgLink,
                      "stretch", // Explicit fitMode for clarity
                      "clip-rect-1" // Unique clipId
                );
  }
  if (sizes && sizes.innerRect2) {
    applyImage(svg, sizes.innerRect2.x + offsetX + 8, 
                    sizes.innerRect2.y + 6  + sizes.overallHeight, 
                    sizes.innerRect2.width , 
                    sizes.innerRect2.height, 
                    imgLink,
                    "stretch", // Explicit fitMode for clarity
                    "clip-rect-2" // Unique clipId
              );
  }
}

export function toSVG(svgString)
{
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
  return d3.select(svgDoc.documentElement);
}

function modifyFileName(filePath) {
    // Extract the file directory, name, and extension using regex or string methods
    const lastSlashIndex = filePath.lastIndexOf("/"); // Find the last "/" in the path
    const directory = filePath.substring(0, lastSlashIndex + 1); // Extract the directory
    const fullFileName = filePath.substring(lastSlashIndex + 1); // Get the file name with extension
    const dotIndex = fullFileName.lastIndexOf("."); // Find the last "." in the file name
    const fileName = fullFileName.substring(0, dotIndex); // Extract the file name without extension
    const extension = fullFileName.substring(dotIndex); // Extract the file extension

    // Construct the new file path with "_bw" appended to the file name
    return `${directory}${fileName}_bw${extension}`;
}

export function handleDoorLiteGrills(svg, sizes, doorLite, doorData = null)
{
  //if (!doorData || !doorData.finish || !doorData.finish.exteriorDoor) return;
  const doorDataCopy = {...doorData};
  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;

  const overallHeight = sizes.overallHeight;
  let grillsColor = 'lightgrey'; //'rgb(151, 151, 151)';
  if (doorDataCopy.doorLite.exteriorFinish === 'Gentek') {
      grillsColor = doorDataCopy.doorLite.gentekColor5;
  }
  else{
    grillsColor = 'white';
  }
  //grillsColor = doorDataCopy.doorLite.gentekColor5;
  //alert(JSON.stringify(doorDataCopy, null, 2));

  if (doorLite.glassDividers.value === 'Grills') {
      // Check and define glassDividersVertical if it doesn't exist
      if (!doorLite.glassDividersVertical) {
          doorLite.glassDividersVertical = { value: 1 };
      } else if (doorLite.glassDividersVertical.value === undefined) {
          doorLite.glassDividersVertical.value = 1;
      } else{
        doorLite.glassDividersVertical.value++;
      }
      
      // Check and define glassDividersHorizontal if it doesn't exist
      if (!doorLite.glassDividersHorizontal) {
          doorLite.glassDividersHorizontal = { value: 1 };
      } else if (doorLite.glassDividersHorizontal.value === undefined) {
          doorLite.glassDividersHorizontal.value = 1;
      }else{
        doorLite.glassDividersHorizontal.value++;
      }
      if ('innerRect1' in sizes) {
        drawGrills(svg, sizes.innerRect1.x + offsetX + 8, 
                        2*8 + 2  + overallHeight, 
                        sizes.innerRect1.width+2*8, 
                        sizes.innerRect1.y + sizes.innerRect1.height -3*8 + 4*2,// - 3*8 - 2*2,  
                        doorLite.glassDividersVertical.value, //cols 
                        doorLite.glassDividersHorizontal.value, //rows
                        1, //scale
                        grillsColor);
      }
      if ('innerRect2' in sizes) {
        drawGrills(svg, sizes.innerRect2.x + offsetX + 8, 
                      2*8 + 2 + overallHeight, 
                      sizes.innerRect2.width+2*8, 
                      sizes.innerRect2.y + sizes.innerRect2.height -3*8 + 4*2,// - 3*8 - 2*2, 
                      doorLite.glassDividersVertical.value, //cols 
                      doorLite.glassDividersHorizontal.value, //rows
                      1, //scale
                      grillsColor);
      }
  }
}

export function handleSideLiteFrame(svg, sizes, doorData = null)
{
  const doorDataCopy = {...doorData};

  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  
  const overallHeight = sizes.overallHeight;
  let grillsColor = 'lightgrey'; //'rgb(151, 151, 151)';
  if (doorDataCopy.sideLite.exteriorFinish === 'Gentek') {
      grillsColor = doorDataCopy.sideLite.gentekColor3;
  }
  else{
    grillsColor = 'white';
  }  
 
  let colorFrame;
  if (doorDataCopy?.finish?.exteriorDoor) {
    if (doorDataCopy.finish.exteriorDoor === 'White') {
      colorFrame = 'White';
    }else{
      if (doorDataCopy.finish.exteriorDoor === 'Gentek') {
        if (doorDataCopy.finish.gentekColor){
          colorFrame = doorDataCopy.finish.gentekColor;
        }
      }
    }
  }
  else{colorFrame = '#F5F5F5';} //default frame color
  if (colorFrame === undefined) {
    colorFrame = '#F5F5F5';
  }
 
  if (true) {

      grillsColor = doorData?.sideLite?.sideLiteOptionsS || '#F5F5F5';
      //=>
        const minWidth = 32;
        if (sizes && sizes.r1) {
          const w = sizes.r1.width + 6*2;
          const h = sizes.r1.height - 4 ;
          const initX = sizes.r1.x + offsetX + 10;
          const initY = sizes.r1.y + sizes.overallHeight + 7;
          if ( w > minWidth){
            drawRect1(svg, initX - 2, initY , w - 16 + 2, h  + 3 , 0, colorFrame, 1, 1);
            drawRect1(svg, initX + 10, initY + 10, w -35, h - 17, 0, grillsColor, 1, 1);
          }
        }
        if (sizes && sizes.r4) {
          const w = sizes.r4.width + 6*2;
          const h = sizes.r4.height - 4;
          const initX = sizes.r4.x + offsetX + 10;
          const initY = sizes.r4.y  + sizes.overallHeight + 7;
          if ( w > minWidth){
            drawRect1(svg, initX - 2, initY , w - 16 + 2, h  + 3 , 0, colorFrame, 1, 1);
            drawRect1(svg, initX + 10, initY + 10, w -35, h - 17, 0, grillsColor, 1, 1);
          }
        }
        else{
          if (sizes && sizes.r3) {
            const w = sizes.r3.width + 6*2;
            const h = sizes.r3.height - 4;
            const initX = sizes.r3.x + offsetX + 10;
            const initY = sizes.r3.y + sizes.overallHeight + 7;
            if ( w > minWidth){
              drawRect1(svg, initX - 2, initY , w - 16 + 2, h  + 3 , 0, colorFrame, 1, 1);
              drawRect1(svg, initX + 10, initY + 10, w -35, h - 17, 0, grillsColor, 1, 1);
            }
          }
        }
  
      //=>
  }//if (1)
}
export function handleSideLiteGrills(svg, sizes, doorData = null, bPaintSideLiteFrame = true)
{
  let deltaFrame = 0;
  if (bPaintSideLiteFrame) {
    deltaFrame = 9;
  }
  const doorDataCopy = {...doorData};

  if (!doorDataCopy || !doorDataCopy.sideLite || !doorDataCopy.sideLite.glassDividers) return;
  const offsetX = -1*sizes.r1.x;
  const offsetY = sizes.r1.Y;
  
  const overallHeight = sizes.overallHeight;
  let grillsColor = 'lightgrey'; //'rgb(151, 151, 151)';
  if (doorDataCopy.sideLite.exteriorFinish === 'Gentek') {
      grillsColor = doorDataCopy.sideLite.gentekColor3;
  }
  else{
    grillsColor = 'white';
  }  
  const parsedV = parseInt(doorDataCopy?.sideLite?.glassDividersVertical);
  const parsedH = parseInt(doorDataCopy?.sideLite?.glassDividersHorizontal);
  let vertical = 0;
  let horizontal = 0;
  if (doorDataCopy.sideLite.glassDividers === 'Grills') {
      vertical   = isNaN(parsedV) ? 0 : parsedV;
      horizontal = isNaN(parsedH) ? 0 : parsedH;
      vertical++;
      horizontal++;

      //=>
        const minWidth = 32;
        if (sizes && sizes.r1) {
          const w = sizes.r1.width + 6*2 - 2*deltaFrame;
          const h = sizes.r1.height - 5 - 2 - 2*deltaFrame;
          const initX = sizes.r1.x + offsetX + 8 + 2 + deltaFrame;
          const initY = sizes.r1.y + 6 + sizes.overallHeight + 2 + deltaFrame;
          
          if ( w > minWidth){
              drawGrills(svg, initX, initY, w, h,
                vertical,   //cols 
                horizontal, //rows
                1, //scale
                grillsColor);
          }
        }
        if (sizes && sizes.r4) {
          const w = sizes.r4.width + 6*2 - 2*deltaFrame;
          const h = sizes.r4.height - 5 - 2 - 2*deltaFrame;
          const initX = sizes.r4.x + offsetX + 8 + 2 + deltaFrame;
          const initY = sizes.r4.y + 6 + sizes.overallHeight + 2 + deltaFrame;
          if ( w > minWidth){
              drawGrills(svg, initX, initY, w, h, 
                vertical,   //cols 
                horizontal, //rows
                1, //scale
                grillsColor);
          }
        }
        else{
          if (sizes && sizes.r3) {
            const w = sizes.r3.width + 6*2 - 2*deltaFrame;
            const h = sizes.r3.height - 5 - 2 - 2*deltaFrame;
            const initX = sizes.r3.x + offsetX + 8 + 2 + deltaFrame;
            const initY = sizes.r3.y + 6 + sizes.overallHeight + 2 + deltaFrame;
            if ( w > minWidth){
                drawGrills(svg, initX, initY, w, h, 
                  vertical,   //cols 
                  horizontal, //rows
                  1, //scale
                  grillsColor);  
            }
          }
        }
  
      //=>
  }//if === 'Grills'
}


export function drawLines(svgString,  doorData = null,   width, height, rows = 1, columns = 4, spacing, fillet,
  outerFrame, outerFrameWidth = 2, w1, w2, w3, w4, innerMargin, transom, sizes, hinges, swing, doorLite, 
  selectedPanel = null, selectedDoorLite = null, frameData = null,
  bDrawHinges = true, bDrawSwing = true) {
  // Parse the SVG string into a DOM element
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');
  const svg = d3.select(svgDoc.documentElement);

  const overallHeight = transom.overallHeight.value;

    
    applySideLiteImages(svg, sizes, modifyFileName("/images/" + "WG00.jpeg"));
    paintDoor(svg, sizes, doorData);
    paintDoorLite(svg, sizes, doorData);
    if (selectedPanel){
        applyDoorImages(svg, sizes, modifyFileName("/images/" + selectedPanel.image));
        applyDoorLiteImages(svg, sizes, selectedDoorLite, frameData );
    }
    //alert(JSON.stringify(sizes, null, 2));
    const bPaintSideLiteFrame = true; //paint side lite frame or not paint
    if (bPaintSideLiteFrame) {
      handleSideLiteFrame(svg, sizes, doorData);
    }
    handleDoorLiteGrills(svg, sizes, doorLite, doorData);
    handleSideLiteGrills(svg, sizes, doorData, bPaintSideLiteFrame);

    var columnWidths = [w1, w2, w3, w4];
        
    var totalWidth = columnWidths.reduce((sum, current) => sum + current, 0) + (columns - 1) * spacing;
    var cellModels = [];
    var xOffset = -width / 2;
    var innerRectModels = {};
    var coordinates = []; // Define the coordinates array before the loops

        for (var i = 0; i < columns; i++) {
            var columnWidth = columnWidths[i];
            var columnHeight = (height -  overallHeight - (rows - 1) * spacing) / rows;

            if (hinges == 'Left') {
              xOffset = columnWidths[0];
            }
            if (hinges == 'Right') {
              xOffset = columnWidths[0]  + columnWidths[1] + spacing;
            }
            
            // Add inner rectangles for w2 and w3
            if (i === 1 || i === 2) {
                var innerWidth = columnWidth - 2 * innerMargin;
                var innerHeight = columnHeight - 2 * innerMargin;
                let yOffsetAdjustment = innerMargin / 2 ;
                let xdelta = innerMargin;
                let ydelta = innerMargin + 3;
                // Draw a diagonal dotted line
                if ((columns === 3) && (i === 1)){
                  if ((hinges === 'Left') && (bDrawHinges) && (!selectedPanel)){
                      svg.append('line')
                      .attr('x1', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta)
                      .attr('y1', overallHeight + yOffsetAdjustment - 3 + ydelta)
                      .attr('x2', columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta) //1
                      .attr('y2',  overallHeight + columnHeight/2)
                      .attr('stroke', 'black')
                      .attr('stroke-dasharray', '6, 4'); // Dotted line

                      svg.append('line')
                      .attr('x1', columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta) //2
                      .attr('y1', overallHeight + columnHeight/2)
                      .attr('x2', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta )
                      .attr('y2',  overallHeight + columnHeight - (ydelta - 7))
                      .attr('stroke', 'black')
                      .attr('stroke-dasharray', '6, 4'); // Dotted line
                      }
                      if ((hinges === 'Right') && ( bDrawHinges) && (!selectedPanel)){
                        svg.append('line')
                        .attr('x1', columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta)
                        .attr('y1', overallHeight + yOffsetAdjustment +ydelta - 3)
                        .attr('x2', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta ) //3
                        .attr('y2',  overallHeight + columnHeight/2)
                        .attr('stroke', 'black')
                        .attr('stroke-dasharray', '6, 4'); // Dotted line

                        svg.append('line')
                        .attr('x1', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta) //4
                        .attr('y1', overallHeight + columnHeight/2)
                        .attr('x2', columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta )
                        .attr('y2',  overallHeight + columnHeight - (ydelta - 7))
                        .attr('stroke', 'black')
                        .attr('stroke-dasharray', '6, 4'); // Dotted line  
                      }
                      if ((swing === 'Inswing') && (bDrawSwing) && (!selectedPanel)) {
                        svg.append('line')
                        .attr('x1', columnWidths[0] +  columnWidth/2 + spacing  + yOffsetAdjustment)
                        .attr('y1', overallHeight + yOffsetAdjustment - 3 + ydelta)
                        .attr('x2', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta )
                        .attr('y2',  overallHeight + columnHeight - (ydelta - 7) )
                        .attr('stroke', 'red')
                        .attr('stroke-dasharray', '6, 4'); // Dotted line
  
                        svg.append('line')
                        .attr('x1', columnWidths[0] + columnWidth/2 + spacing + yOffsetAdjustment)
                        .attr('y1', overallHeight + yOffsetAdjustment - 3  + ydelta)
                        .attr('x2',  columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta - 3 )
                        .attr('y2',  overallHeight + columnHeight - (ydelta - 7 ))
                        .attr('stroke', 'red')
                        .attr('stroke-dasharray', '6, 4'); // Dotted line
                      }
                }
                if (columns === 4){
                  if(bDrawHinges && (!selectedPanel)) { 
                    svg.append('line')
                    .attr('x1', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta)
                    .attr('y1', overallHeight + yOffsetAdjustment - 3 + ydelta)
                    .attr('x2', columnWidths[0] + columnWidth - yOffsetAdjustment  )
                    .attr('y2',  overallHeight + columnHeight/2)
                    .attr('stroke', 'black')
                    .attr('stroke-dasharray', '6, 4'); // Dotted line
                    
                    svg.append('line')
                    .attr('x1', columnWidths[0] + columnWidth - yOffsetAdjustment + innerMargin - xdelta) //2
                    .attr('y1', overallHeight + columnHeight/2)
                    .attr('x2', columnWidths[0] + spacing  + yOffsetAdjustment + xdelta )
                    .attr('y2',  overallHeight + columnHeight - (ydelta - 7))
                    .attr('stroke', 'black')
                    .attr('stroke-dasharray', '6, 4'); // Dotted line

                    svg.append('line')
                    .attr('x1', columnWidths[0] + columnWidth - yOffsetAdjustment + columnWidths[1] )
                    .attr('y1', overallHeight + yOffsetAdjustment - 3 + ydelta)
                    .attr('x2',  columnWidths[0] + columnWidth + yOffsetAdjustment  + spacing + xdelta )
                    .attr('y2',  overallHeight + columnHeight/2)
                    .attr('stroke', 'black')
                    .attr('stroke-dasharray', '6, 4'); // Dotted line 

                    svg.append('line')
                    .attr('x1',  columnWidths[0] + columnWidth + yOffsetAdjustment  + spacing + xdelta )
                    .attr('y1',  overallHeight + columnHeight/2)
                    .attr('x2', columnWidths[0] + columnWidth - yOffsetAdjustment + columnWidths[1] )
                    .attr('y2', overallHeight + columnHeight + yOffsetAdjustment - 0 - ydelta)
                    .attr('stroke', 'black')
                    .attr('stroke-dasharray', '6, 4'); // Dotted line 
                  }    

                  if ((swing === 'Inswing') && (bDrawSwing) && (!selectedPanel)) {
                      svg.append('line')
                      .attr('x1', xOffset +  columnWidth/2 + spacing  + yOffsetAdjustment)
                      .attr('y1', overallHeight + yOffsetAdjustment - 3 + ydelta)
                      .attr('x2', xOffset + columnWidth - yOffsetAdjustment  + innerMargin - xdelta)
                      .attr('y2',  overallHeight + columnHeight - (ydelta - 7))
                      .attr('stroke', 'red')
                      .attr('stroke-dasharray', '6, 4'); // Dotted line

                      svg.append('line')
                      .attr('x1', xOffset + columnWidth/2 + spacing + yOffsetAdjustment)
                      .attr('y1', overallHeight + yOffsetAdjustment - 3 +  ydelta)
                      .attr('x2',  xOffset + yOffsetAdjustment  + spacing + xdelta)
                      .attr('y2',  overallHeight + columnHeight - (ydelta - 7))
                      .attr('stroke', 'red')
                      .attr('stroke-dasharray', '6, 4'); // Dotted line
                  }
                }//if columns === 4
            }//if 1,2
        }//for

        if (transom.transom.value !== "None") { //draw & paint overall height...
          //drawTransomGradient(svg);
          //alert(JSON.stringify(doorData, null, 2));
          //alert(doorData.transomData.transomGlass_label + " " + doorData.transomData.transomGlass);
          //alert(doorData.transomData.transomHeight + " " + doorData.transomData.transomWidth);

          // Draw a rectangle and apply the gradient
          if (transom.transom.value === "Rectangle") { //'rectangle'
            let width1 = width - 2 * spacing + 4;
            let height1 = overallHeight - 2 * outerFrameWidth + 4;
            let pureDelta = 6;
 
            
            drawTransomRectangleFrame(svg, spacing + pureDelta, 
                                           spacing + pureDelta, 
                                           width - 2 * spacing + 3 - 2*pureDelta,
                                           overallHeight - 2 * outerFrameWidth + 4 - 2*pureDelta + 4, 
                                           getExteriorDoorcolor(doorData));
            pureDelta = pureDelta * 3;                              
            drawTransomRectangleFrame(svg, spacing + pureDelta, 
                                            spacing + pureDelta, 
                                            width - 2 * spacing + 3 - 2*pureDelta,
                                            overallHeight - 2 * outerFrameWidth + 4 - 2*pureDelta + 4, 
                                            getExteriorDoorcolor(doorData));   
            /*drawTransomRectangleFrameMain( svg, spacing, spacing, 
            width - 2 * spacing + 3, overallHeight - 2 * outerFrameWidth + 4, doorData);  */    

            drawTransomGlass(svg, spacing  + pureDelta, spacing  + pureDelta, 
                            width - 2 * spacing + 3 - 2*pureDelta, 
                            overallHeight - 2 * outerFrameWidth + 4 - 2*pureDelta + 4, 
                              doorData.transomData.transomGlass);
            drawTransomRectangle(svg, spacing, spacing, width - 2 * spacing + 3, overallHeight - 2 * outerFrameWidth + 5);  

          }
          if (transom.transom.value === "Ellipse") { //ellipse
            eraseTransomeRectangle(svg, spacing, spacing, width - 2 * spacing + 3, overallHeight - 2 * outerFrameWidth + 4);
            let width1 = width - 2 * spacing + 4;
            let height1 = overallHeight - 2 * outerFrameWidth + 4;
            drawTransomEllipse(svg, width1, height1, spacing);
            drawTransomEllipseGlass(svg, width1, height1, spacing, doorData.transomData.transomGlass);
          }
        }
  const serializer = new XMLSerializer();
  return serializer.serializeToString(svg.node());
}
function drawTransomGradient(svg)
{
    const defs = svg.append('defs');
    const gradient = defs.append('linearGradient')
        .attr('id', 'gradient')
        .attr('x1', '0%')
        .attr('y1', '100%')
        .attr('x2', '0%')
        .attr('y2', '0%');
    
    gradient.append('stop')
        .attr('offset', '0%')
        .attr('style', 'stop-color:rgb(166, 196, 249);;stop-opacity:1');
    gradient.append('stop')
        .attr('offset', '100%')
        .attr('style', 'stop-color:white;stop-opacity:1');
}
function drawTransomGlass(svg, x, y, width, height, color)
{
  svg.append('rect')
  .attr('x', x)
  .attr('y', y)
  .attr('width', width)
  .attr('height', height)
  .attr('fill', color);
}
function drawTransomRectangle(svg, x, y, width, height, fill='url(#gradient)')
{
    svg.append('rect')
    .attr('x', x)
    .attr('y', y)
    .attr('width', width)
    .attr('height', height)
    .attr('stroke', 'black') // Border color
    .attr('stroke-width', 0.5) // Border thickness
    .attr('fill', fill); 
}
function drawTransomRectangleFrame(svg, x, y, width, height, fill='url(#gradient)')
{
    svg.append('rect')
    .attr('x', x)
    .attr('y', y)
    .attr('width', width)
    .attr('height', height)
    .attr('stroke', 'black') // Border color
    .attr('stroke-width', 0.5) // Border thickness
    .attr('fill', fill); 
}

function drawTransomRectangleFrameMain(svg, x, y, width, height, doorData = null)
{
  let pureDelta = 6;

  drawTransomRectangleFrame(svg, x + pureDelta, //draw outer rect
    y + pureDelta, 
    width- 2*pureDelta,
    height - 2*pureDelta, 
    getExteriorDoorcolor(doorData));

    pureDelta = pureDelta * 3;

  drawTransomRectangleFrame(svg, x + pureDelta, //draw inner rect
     y + pureDelta, 
     width - 2*pureDelta,
     height - 2*pureDelta, 
     getExteriorDoorcolor(doorData));   
}
function drawRectOutline(svg, x, y, width, height, strokeColor = 'black', strokeWidth = 2) {
  svg.append('rect')
      .attr('x', x)
      .attr('y', y)
      .attr('width', width)
      .attr('height', height)
      .attr('fill', 'none') // No fill
      .attr('stroke', strokeColor) // Border color
      .attr('stroke-width', strokeWidth); // Border thickness
}

function eraseTransomeRectangle(svg, x, y, width, height)
{
    const pen = 2;
    svg.append('rect') //erase rectangle borders...
    .attr('x', x - pen)
    .attr('y', y - pen)
    .attr('width', width + 2*pen)
    .attr('height', height + 2*pen)
    .attr('fill', 'white'); 
}
function drawTransomEllipse(svg, width1, height1, spacing, fill='url(#gradient)')
{
    //  let width1 = width - 2 * spacing + 3;
    //  let height1 = overallHeight - 2 * outerFrameWidth + 4;
      let majorRadius, minorRadius;

      if (width1 > height1) {
          majorRadius = width1 / 2; // Horizontal radius
          minorRadius = height1;   // Vertical radius
      } else if (width1 < height1) {
          majorRadius = height1;   // Vertical radius
          minorRadius = width1 / 2; // Horizontal radius
      } else {
          majorRadius = minorRadius = width1 / 2; // Circle case
      }

      // Add the half-ellipse
      svg.append('path')
      .attr('d', `
          M ${spacing} ${spacing + height1} 
          A ${majorRadius} ${minorRadius} 
          0 0 1 
          ${spacing + width1} ${spacing + height1}
      `) // Arc path: touches rectangle's edges
      .attr('fill', fill); // Solid color for the half-ellipse
}
function drawTransomEllipseGlass(svg, width1, height1, spacing, color) {
  let majorRadius, minorRadius;

  if (width1 > height1) {
      majorRadius = width1 / 2;
      minorRadius = height1;
  } else if (width1 < height1) {
      majorRadius = height1;
      minorRadius = width1 / 2;
  } else {
      majorRadius = minorRadius = width1 / 2;
  }

  svg.append('path')
      .attr('d', `
          M ${spacing} ${spacing + height1} 
          A ${majorRadius} ${minorRadius} 
          0 0 1 
          ${spacing + width1} ${spacing + height1}
      `)
      .attr('fill', color) // No fill, just the line
      .attr('stroke', 'black') // Line color
      .attr('stroke-width', 0.5); // Optional: line thickness
}



//export default drawLines;